import 'react-international-phone/style.css';

import { InputAdornment, MenuItem, Select, Typography } from '@mui/material';
import React from 'react';
import {
  CountryIso2,
  defaultCountries,
  parseCountry,
  ParsedCountry,
  usePhoneInput,
} from 'react-international-phone';
import TextField, { ITextFieldProps } from '../TextField/TextField';
import OfflineFlag from './OfflineFlag';

import { ReactComponent as ArrowDown } from '../../../../assets/icons/ArrowDown.svg';

import { useStyles } from './styles';

export interface MUIPhoneProps extends ITextFieldProps {
  defaultCountry?: CountryIso2;
  onChange: (data: { phone: string; inputValue: string; country: ParsedCountry }) => void;
}

export const MobileInput: React.FC<MUIPhoneProps> = ({ label, value, placeholder, onChange, testId, ...restProps }) => {
  const { inputValue, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
    defaultCountry: 'us',
    value,
    countries: defaultCountries,
    onChange: onChange,
  });

  const classes = useStyles();

  return (
    <TextField
      label={label}
      placeholder={placeholder}
      value={inputValue}
      onChange={handlePhoneValueChange}
      type="tel"
      inputRef={inputRef}
      testId={testId}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Select
              data-testid={testId ? `${testId}-country-select` : undefined}
              MenuProps={{
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                className: classes.menu,
              }}
              className={classes.countryFlagDropdown}
              displayEmpty
              IconComponent={ArrowDown}
              value={country.iso2}
              disabled={restProps.disabled}
              onChange={e => setCountry(e.target.value as CountryIso2)}
              renderValue={value => (
                <OfflineFlag iso2={value} className={classes.countryFlagSelected} />
              )}
            >
              {defaultCountries.map(c => {
                const country = parseCountry(c);
                return (
                  <MenuItem
                    key={country.iso2}
                    value={country.iso2}
                    data-testid={testId ? `${testId}-country-option-${country.iso2}` : undefined}
                    className={`${classes.menuItem}`}
                  >
                    <OfflineFlag iso2={country.iso2} className={classes.countryFlag} />
                    <Typography className={classes.countryName}>{country.name}</Typography>
                    <Typography className={classes.countryCode}>+{country.dialCode}</Typography>
                  </MenuItem>
                );
              })}
            </Select>
          </InputAdornment>
        ),
      }}
      {...restProps}
    />
  );
};

export default React.memo(MobileInput);
